import { render, staticRenderFns } from "./CouponItemTab.vue?vue&type=template&id=152f3932"
import script from "./CouponItemTab.vue?vue&type=script&lang=js"
export * from "./CouponItemTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152f3932')) {
      api.createRecord('152f3932', component.options)
    } else {
      api.reload('152f3932', component.options)
    }
    module.hot.accept("./CouponItemTab.vue?vue&type=template&id=152f3932", function () {
      api.rerender('152f3932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponPackage/CouponItemTab.vue"
export default component.exports